import Enumeration from '@enums/enum';

/**
 * The offer rate types.
 */
const RateTypeEnum = new Enumeration({
  FIXED: 'fixed',
  VARIABLE: 'variable',
});

export default RateTypeEnum;
